import { graphql, readInlineData } from "react-relay";

import { section as sectionData } from "~/data";
import type { helpersStyleSectionContent$key } from "~/queries/__generated__/helpersStyleSectionContent.graphql";

export const checkIsStyleSectionContent = (reference: helpersStyleSectionContent$key) => {
  const section = readInlineData(
    graphql`
      fragment helpersStyleSectionContent on Section @inline {
        fullSectionPath {
          entityId
        }
      }
    `,
    reference,
  );

  const [firstSectionEntityId, secondSectionEntityId] =
    section?.fullSectionPath?.flatMap(s => s?.entityId) ?? [];
  return (
    firstSectionEntityId === sectionData.magazine.entityId &&
    secondSectionEntityId === sectionData.style.entityId
  );
};
